import { render, staticRenderFns } from "./ConfirmDelete.vue?vue&type=template&id=e8951680&scoped=true"
import script from "./ConfirmDelete.vue?vue&type=script&lang=js"
export * from "./ConfirmDelete.vue?vue&type=script&lang=js"
import style0 from "./ConfirmDelete.vue?vue&type=style&index=0&id=e8951680&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8951680",
  null
  
)

export default component.exports